module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('help-head')], 1), _vm._v(" "), _c('div', {
    staticClass: "crumb"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'EntryPage'
      }
    }
  }, [_vm._v("首页")])], 1), _vm._v(" >\n        "), _c('span', [_vm._v("关于")])]), _vm._v(" "), _c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "cont-head"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": require("../../../../static/image/icon.png")
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "cont-title"
  }, [_vm._v("远程教学系统")]), _vm._v(" "), _c('div', {
    staticClass: "verinfor"
  }, [_c('a', {
    staticClass: "verinfor-btn s-btn",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.verinfor
    }
  }, [_vm._v("版本记录")])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "dialog"
  }, [_c('el-dialog', {
    attrs: {
      "title": "版本记录",
      "visible": _vm.centerDialogVisible,
      "width": "50%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('p', {
    staticClass: "text"
  }, [_c('strong', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("V2.0.2")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("2019年4月14号")]), _vm._v(" "), _c('P', {
    staticClass: "text_ver"
  }, [_vm._v("-专题读片与教学管理的列表操作中增加通过二维码进入会议与课程的功能。")]), _vm._v(" "), _c('p', {
    staticClass: "text_ver"
  }, [_vm._v("-新增首页的界面的显示功能。")]), _vm._v(" "), _c('p', {
    staticClass: "text_ver"
  }, [_vm._v("-新增消息框提示功能。")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('strong', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("V2.0.1")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("2019年1月14号")]), _vm._v(" "), _c('P', {
    staticClass: "text_ver"
  }, [_vm._v("-涉及【附件】【病例资料】【影像】的界面增加对应数量展示优化。")]), _vm._v(" "), _c('p', {
    staticClass: "text_ver"
  }, [_vm._v("-新增帮助和关于的显示功能。")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('strong', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("V2.0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("2018年11月20号")]), _vm._v(" "), _c('p', {
    staticClass: "text_ver"
  }, [_vm._v("-涉及历史检查阅片中支持多个阅片功能的优化。")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('strong', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("V1.0.1")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("2018年6月15号")]), _vm._v(" "), _c('p', {
    staticClass: "text_ver"
  }, [_vm._v("-新增专题读片，教学中心和教学管理功能模块。")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('strong', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("V1.0.0")])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("2018年4月20号")]), _vm._v(" "), _c('p', {
    staticClass: "text_ver"
  }, [_vm._v("-新增资料中心，每日读片和典型病例库功能模块。")])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cont-message"
  }, [_c('p', [_vm._v("版本号：V2.0.2")]), _vm._v(" "), _c('p', [_vm._v("联系电话：400-0571-574")]), _vm._v(" "), _c('p', [_vm._v("联系地址：杭州市上城区中河中路198号绿都大厦4F、5F")]), _vm._v(" "), _c('p', [_vm._v("Copyright © Hangzhou Lianzhong Medical Science Co., Ltd.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-237f4c26","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/about/about.vue
// module id = 539
// module chunks = 1 2 3 4 5 6 7 8